<!-- 查询组件 -->
<template>
  <div class="query-container">
    <el-form
      ref="form"
      :model="params"
      class="form-container"
      size="small"
      :label-position="$i18n.locale !== 'zh' ? 'top' : 'right'"
      :label-width="$i18n.locale !== 'zh' ? 'auto' : '160px'"
    >
      <!-- 运输单号-->
      <el-form-item v-if="[5].includes(payableType)" :label="$t('basicData.TransportOrderNumber')">
        <InputTextareaCmp
          ref="transportNumberStr"
          :val="transportNumber"
          :max-length="2000"
        />
      </el-form-item>
      <!--应付主体-->
      <el-form-item :label="$t('basicData.PayablePrincipal')">
        <QueryProviderCmp
          :val="params.providerId"
          :type="payableType"
          @change="val => params.providerId = val"
        />
      </el-form-item>

      <!--运输类型屏蔽字段-->
      <template v-if="payableType !== 5">
        <!-- 网点 -->
        <el-form-item :label="$t('basicData.Outlets')">
          <QuerySiteCmp
            :val="params.siteId"
            :provider-id="params.providerId"
            @change="val => params.siteId = val"
          />
        </el-form-item>
        <!-- 客户 -->
        <el-form-item :label="$t('basicData.CustomerName')">
          <QueryCustomerCmp :val="params.customerId" @change="val => params.customerId = val" />
        </el-form-item>

        <!--客户编号-->
        <el-form-item :label="$t('basicData.CustomerCode')">
          <QueryCustomerCodeCmp :val="params.customerCodeId" @change="val => params.customerCodeId = val" />
        </el-form-item>
      </template>

      <!--服务商渠道-->
      <el-form-item
        v-if="payableType === 6"
        :label="$t('GlobalSetObj.ServiceProviderChannels')"
      >
        <el-select
          v-model="params.providerChannelId"
          filterable
          clearable
          :placeholder="$t('GlobalSetObj.pleaseSelectChannel')"
          style="width: 100%;"
        >
          <el-option
            v-for="item in ProviderChannelList"
            :key="item.id"
            :label="item.providerChannelName"
            :value="item.id"
          />
        </el-select>
      </el-form-item>

      <!-- 业务时间 -->
      <el-form-item :label="$t('basicData.BusinessTime')">
        <template slot="label">
          <el-select
            v-model="params.timeField"
            :placeholder="$t('operationCenter.PleaseSelect')"
          >
            <el-option
              v-for="item in TIME_TYPE"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
        <el-date-picker
          v-model="queryDate"
          style="width: 100%"
          type="datetimerange"
          :picker-options="dateLimit"
          :default-time="['00:00:00', '23:59:59']"
          :range-separator="$t('operationCenter.to')"
          :start-placeholder="$t('operationCenter.startDate')"
          :end-placeholder="$t('operationCenter.endDate')"
          value-format="yyyy-MM-dd HH:mm:ss"
        />
      </el-form-item>

      <!-- 业务单号 / 订单号 / 客户单号 -->
      <el-form-item v-if="payableType !== 5">
        <template slot="label">
          <el-select
            v-model="params.numberField"
            :placeholder="$t('operationCenter.PleaseSelect')"
          >
            <el-option
              v-for="item in ORDER_TYPE"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
        <InputTextareaCmp
          ref="InputTextareaRef"
          :val="textVal"
          :max-length="30000"
        />
      </el-form-item>

      <!-- 揽收操作人 -->
      <el-form-item v-if="[1,2].includes(payableType)" :label="payableType === 2 ? $t('GlobalSetObj.driver') : $t('basicData.揽收操作人')">
        <CollectorsCmp
          v-model="params.collectorIdList"
          @change="val => params.collectorIdList = val"
        />
      </el-form-item>
      <!-- 派件操作人 -->
      <el-form-item v-else-if="[3,4,6].includes(payableType)" :label="$t('basicData.派送操作人')">
        <SendCmp
          v-model="params.dispatcherList"
          :payable-type="payableType"
          @change="val => params.dispatcherList = val"
        />
      </el-form-item>

      <!--批次号-->
      <el-form-item v-if="selectKey === 1" :label="$t('basicData.BatchNo')">
        <el-input
          v-model="params.billBatchNumber"
          :readonly="isReadOnly"
        />
      </el-form-item>

      <!--收款单号-->
      <el-form-item v-if="selectKey === 2" :label="$t('receivablePayable.PaymentSlipNumber')">
        <el-input
          v-model="params.payableNumber"
          :readonly="isReadOnly"
        />
      </el-form-item>

      <!-- 是否已支付 -->
      <el-form-item :label="$t('receivablePayable.WhetherItHasBeenPaid') ">
        <el-select
          v-model="params.isAccept"
          filterable
          clearable
          :placeholder="$t('operationCenter.PleaseSelect')"
          style="width: 100%;"
        >
          <el-option :label="$t('GlobalSetObj.yes')" :value="1" />
          <el-option :label="$t('GlobalSetObj.No')" :value="0" />
        </el-select>
      </el-form-item>

      <!-- 是否生成对账单 -->
      <el-form-item :label="$t('receivablePayable.WhetherToGenerateAStatement')">
        <el-select
          v-model="params.isGenBill"
          filterable
          clearable
          :placeholder="$t('operationCenter.PleaseSelect')"
          style="width: 100%;"
        >
          <el-option :label="$t('GlobalSetObj.yes')" :value="1" />
          <el-option :label="$t('GlobalSetObj.No')" :value="0" />
        </el-select>
      </el-form-item>

      <!--业务类型-->
      <el-form-item
        v-if="[2].includes(payableType)"
        :label="$t('collectionCenter.businessT')"
      >
        <el-select
          v-model="params.orderBusinessType"
          clearable
          :placeholder="$t('basicData.PleaseSelect')"
          style="width: 100%;"
        >
          <!--0 揽收 1 快递-->
          <el-option
            v-for="item in ORDER_BUSINESS_TYPE"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <!--揽收方式-->
      <el-form-item
        v-if="[1, 2].includes(payableType)"
        :label="$t('collectionCenter.lanshouTypee')"
      >
        <el-select
          v-model="params.collectType"
          clearable
          :placeholder="$t('basicData.PleaseSelect')"
          style="width: 100%;"
        >
          <!--1 上门交件 2 上门揽收-->
          <el-option
            v-for="item in COLLECT_TYPE"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <!-- 费用类型 -->
      <el-form-item v-if="[1,2,3,4,6].includes(payableType)" :label="$t('basicData.ExpenseType')">
        <FeeCodeCmp
          :val="params.feeCodeList" :business-type="payableType"
          :multiple="true"
          :limit="5"
          :placeholder="$t('GlobalSetObj.multipleChoice')"
          @change="val => params.feeCodeList = val"
        />
      </el-form-item>

      <!-- 订单状态 -->
      <el-form-item v-if="[1,2,3,4,6].includes(payableType)" :label="$t('receivablePayable.orderStatus')">
        <el-select
          v-model="params.status"
          filterable
          clearable
          :placeholder="$t('operationCenter.PleaseSelect')"
          style="width: 100%;"
        >
          <el-option
            v-for="item in ORDER_STATUS"
            :key="item.code"
            :label="item.label"
            :value="item.code"
          />
        </el-select>
      </el-form-item>

      <!-- 发件人州 -->
      <el-form-item v-if="[1,2].includes(payableType)" :label="$t('newOrder.SenderState')">
        <el-select
          v-model="params.senderState"
          :placeholder="$t('placeOrder.pleaseChoose')"
          clearable
          filterable
          style="width: 100%"
        >
          <el-option
            v-for="item in stateList"
            :key="item.id"
            :label="item.shortName"
            :value="item.shortName"
          />
        </el-select>
      </el-form-item>
      <!-- 收件人州 -->
      <el-form-item v-if="[3,4,6].includes(payableType)" :label="$t('newOrder.RecipientState')">
        <el-select
          v-model="params.receiveState"
          :placeholder="$t('placeOrder.pleaseChoose')"
          clearable
          filterable
          style="width: 100%"
        >
          <el-option
            v-for="item in stateList"
            :key="item.id"
            :label="item.shortName"
            :value="item.shortName"
          />
        </el-select>
      </el-form-item>
      <!-- 车签号 -->
      <el-form-item v-if="[2].includes(payableType)" :label="$t('GlobalSetObj.NIV')">
        <el-input
          v-model="params.tagNumber"
          clearable
          :placeholder="$t('GlobalSetObj.pleaseInput')"
        />
      </el-form-item>
      <!-- 车牌号 -->
      <el-form-item v-if="[2, 5].includes(payableType)" :label="$t('GlobalSetObj.licensePlateNumber')">
        <el-input
          v-if="payableType === 2"
          v-model="params.vehicleNumber"
          clearable
          :placeholder="$t('GlobalSetObj.pleaseInput')"
        />
        <el-select
          v-else
          v-model="params.vehicleNumber"
          clearable
          filterable
          :placeholder="$t('operationCenter.PleaseSelect')"
          style="width: 100%"
        >
          <el-option
            v-for="item in vehicleList"
            :key="item.id"
            :label="item.vehicleName"
            :value="item.vehicleName"
          />
        </el-select>
      </el-form-item>
      <!-- 商户号 -->
      <el-form-item v-if="[2].includes(payableType)" :label="$t('placeOrder.CommercialOwner')">
        <ComerCianteCmp
          :val="params.merchantId"
          @change="onComercianteChange"
        />
      </el-form-item>
      <template v-if="[5].includes(payableType)">
        <!-- 司机-->
        <el-form-item :label="$t('GlobalSetObj.driver')">
          <el-select
            v-model="params.driverId"
            :placeholder="$t('operationCenter.PleaseSelect')"
            clearable
            filterable
            style="width: 100%;"
          >
            <el-option
              v-for="item in driverList"
              :key="item.id"
              :label="item.driversName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <!-- 车线名称 -->
        <el-form-item :label="$t('basicData.routeName')">
          <el-select
            v-model="params.lineId"
            filterable
            clearable
            :placeholder="$t('operationCenter.PleaseSelect')"
            style="width: 100%;"
          >
            <el-option
              v-for="item in stitchingLine"
              :key="item.id"
              :label="item.name + '（' + item.code + '）'"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <!-- 车辆类型 -->
        <el-form-item :label="$t('collectionCenter.carType')">
          <el-select
            v-model="params.vehicleType"
            filterable
            clearable
            :placeholder="$t('operationCenter.PleaseSelect')"
            style="width: 100%;"
          >
            <el-option
              v-for="item in modelList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <!-- 运输类型 -->
        <el-form-item :label="$t('basicData.transportType')">
          <el-select
            v-model="params.routeType"
            filterable
            clearable
            :placeholder="$t('operationCenter.PleaseSelect')"
            style="width: 100%;"
          >
            <el-option
              v-for="item in TRANSPORTATION_TYPE"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </template>
      <!-- 货物类型-->
      <el-form-item v-if="[3, 4].includes(payableType)" :label="$t('placeOrder.cargoType')">
        <el-select
          v-model="params.cargoType"
          filterable
          clearable
          :placeholder="$t('operationCenter.PleaseSelect')"
          style="width: 100%;"
        >
          <el-option
            v-for="item in CARGO_TYPE"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
    </el-form>

    <div class="form-footer">
      <!--查 询-->
      <el-button
        type="primary"
        size="small"
        @click="onSearch"
      >{{ $t('basicData.Search') }}</el-button>
      <!--重 置-->
      <el-button
        type="success"
        size="small"
        @click="onReset"
      >{{ $t('basicData.reset') }}</el-button>
      <!--取 消-->
      <el-button
        size="small"
        @click="onClose"
      >{{ $t('basicData.Cancel') }}</el-button>
    </div>
  </div>
</template>

<script>
import { selectState } from '@/api/orderApi';
import { WAYBILL_STATUS, ORDER_TYPE_LIST, ORDER_BUSINESS_TYPE, COLLECT_TYPE, CARGO_TYPE } from '@/views/finance/enums';
import { TRANSPORTATION_TYPE } from '@/views/finance/utils';
import {
  beforeSearch,
  DELIVERY,
  NUMBER_FIELD,
  SEARCH_PARAMS, TIME_SEARCH_ITEM
} from '@/views/finance/payableManage/feesPayable/enums.js';
import toolRequestClass from '@/views/finance/mixins/toolRequestClass';
import { cloneDeep } from 'lodash-es';

export default {
  name: 'QuerySearchCmp',
  components: {
    QueryProviderCmp: () => import('@/views/finance/cmp/Query/QueryProviderCmp.vue'),
    QueryCustomerCmp: () => import('@/views/finance/cmp/Query/QueryCustomerCmp.vue'),
    QueryCustomerCodeCmp: () => import('@/views/finance/cmp/Query/QueryCustomerCodeCmp.vue'),
    QuerySiteCmp: () => import('@/views/finance/cmp/Query/QuerySiteCmp.vue'),
    InputTextareaCmp: () => import('@/views/finance/cmp/Query/InputTextareaCmp.vue'),
    CollectorsCmp: () => import('@/views/finance/cmp/Query/CollectorsCmp.vue'),
    SendCmp: () => import('@/views/finance/cmp/Query/SendCmp.vue'),
    FeeCodeCmp: () => import('@/views/finance/cmp/Query/FeeCodeCmp.vue'),
    ComerCianteCmp: () => import('@/views/finance/cmp/Query/ComercianteCmp.vue')
  },
  mixins: [toolRequestClass],

  props: {
    // 账单类型
    payableType: {
      type: [Number, String],
      default: () => null,
      required: true
    },
    // 是否只读
    isReadOnly: {
      type: Boolean,
      default: false
    },
    // 1 批次号 2 对账单
    selectKey: {
      type: [String, Number],
      default: ''
    },
    // 批次号/对账单号
    billBatchNumber: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      COLLECT_TYPE,
      ORDER_BUSINESS_TYPE,
      CARGO_TYPE,
      TRANSPORTATION_TYPE,
      loading: false,
      params: {
        ...SEARCH_PARAMS
      },
      queryDate: [], // 业务时间
      textVal: '', // 输入框内容
      transportNumber: '', // 运输单号
      // 日期限制
      pickerMinDate: '',
      pickerRange: 15 * 24 * 60 * 60 * 1000, // 可选择日期范围 为15天，DSP派送为30天
      // loadUserList: [], // 装车人
      // ORDER_TYPE: [],
      ORDER_STATUS: [],
      // 是否为DSP派送页面
      // isDSPDispatch: this.$route.path === '/finance/payableManagement/feesPayable/DSPDispatch',
      stateList: [] // 收发件人州省
    };
  },
  computed: {
    /**
     * 日期限制处理
     *    默认情况下限制15天
     *    如果输入了 业务单号 或 客户单号 或 批次号，则不限制时间
     */
    dateLimit() {
      const { textVal, pickerMinDate, pickerRange } = this;
      const { billBatchNumber, payableNumber } = this.params;

      // 默认限制15天
      return {
        // 设置不能选择的日期
        onPick: ({ minDate }) => {
          // 输入了内容
          if (textVal || billBatchNumber || payableNumber) {
            // 取消限制
            this.pickerMinDate = null;
            return;
          }

          if (minDate && pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          // 输入了内容
          if (textVal || billBatchNumber || payableNumber) {
            // 取消时间限制
            return false;
          }

          if (this.pickerMinDate) {
            return (time.getTime() > (pickerMinDate + pickerRange)) || (time.getTime() < (pickerMinDate - pickerRange));
          }
          return false;
        }
      };
    },

    // 订单类型 payableType: 1 第三方 2 安骏 3 AJD派送 4 DSP派送 5 运输干/支线 6 邮局
    ORDER_TYPE() {
      if ([1, 2].includes(this.payableType)) {
        return NUMBER_FIELD;
      } else if (this.payableType === 3) {
        const deliveryCopy = { ...DELIVERY };
        delete deliveryCopy['provider_number'];
        return deliveryCopy;
      } else if ([4, 5, 6].includes(this.payableType)) {
        return DELIVERY;
      }
      return {};
    },

    // 业务时间
    TIME_TYPE() {
      if ([5].includes(this.payableType)) {
        return TIME_SEARCH_ITEM;
      } else {
        const deliveryCopy = { ...TIME_SEARCH_ITEM };
        delete deliveryCopy['transport_date_time'];
        return deliveryCopy;
      }
    }
  },
  // DSP/干支线 查询一个月
  watch: {
    // payableType: {
    //   handler(val) {
    //     if (val) {
    //       this.pickerRange = 30 * 24 * 60 * 60 * 1000;
    //     } else {
    //       this.pickerRange = 15 * 24 * 60 * 60 * 1000;
    //     }
    //   },
    //   immediate: true
    // },

    // 账单类型
    payableType: {
      handler(val) {
        if (val === 5) {
          // 获取车线
          this.getApiCarLineDispatchSystemList();
          // 获取车型
          this.getApiOptionForSelect();
        }
        if (val === 6) {
          // 获取服务商渠道
          this.getProviderChannel();
        }
        // 设置查询日期 DSP/干支线查询30天
        if ([4, 5].includes(val)) {
          this.pickerRange = 30 * 24 * 60 * 60 * 1000;
        } else {
          this.pickerRange = 15 * 24 * 60 * 60 * 1000;
        }
      },
      immediate: true
    }
  },

  created() {
    // 订单类型
    // this.ORDER_TYPE = [1, 2].includes(this.payableType) ? NUMBER_FIELD : DELIVERY;
    // 订单状态
    this.ORDER_STATUS = ([1, 2].includes(this.payableType) ? ORDER_TYPE_LIST : WAYBILL_STATUS).map(item => ({
      code: [1, 2].includes(this.payableType) ? item.collectStatus : item.code,
      label: [1, 2].includes(this.payableType) ? item.collectStatusName : item.label
    }));

    // 根据selectKey的值，决定是赋值给billBatchNumber还是payableNumber
    if (this.selectKey) {
      this.params[this.selectKey === 1 ? 'billBatchNumber' : 'payableNumber'] = this.billBatchNumber;
    }

    // 收发件人州省
    this.getState();

    if (this.payableType === 5) {
      this.getCarNumber(); // 车牌号
      this.getDriverInfo(); // 司机信息
    }
  },

  methods: {
    // 商户变化
    onComercianteChange(val) {
      this.params.merchantId = val?.value;
      this.params.merchantCode = val?.code;
    },

    // 重置
    onReset() {
      this.params = { ...SEARCH_PARAMS };
      this.queryDate = [];
      this.textVal = '';
      this.transportNumber = '';
      if (this.payableType === 5) {
        this.$refs.transportNumberStr.clear();
      } else {
        this.$refs.InputTextareaRef.clear();
      }
      // 根据selectKey的值，决定是赋值给billBatchNumber还是payableNumber
      if (this.selectKey) {
        this.params[this.selectKey === 1 ? 'billBatchNumber' : 'payableNumber'] = this.billBatchNumber;
      }
    },

    // 搜索
    onSearch() {
      const obj = cloneDeep(this.params);
      try {
        // 业务时间
        obj.startTime = this.queryDate?.length > 0 ? this.queryDate[0] : '';
        obj.endTime = this.queryDate?.length > 0 ? this.queryDate[1] : '';
        // 运输单号
        if (this.payableType === 5) {
          obj.transportNumberList = this.$refs.transportNumberStr.getValue();
          obj.status = '';
          obj.numberField = 'transport_number';
        } else {
          // 业务单号
          obj.numberList = this.$refs.InputTextareaRef.getValue();
          console.info(this.$refs.InputTextareaRef);
        }
        // 如果是DSP派送页面，限制选择了时间必须选择网点
        // 1247 暂时去掉这个校验逻辑，因为DSP派送页面，时间选了，但是没有网点，也能查到数据。
        // if (this.isDSPDispatch) {
        //   if (obj.startTime && obj.endTime && !obj.siteId) {
        //     return this.$message.warning(this.$t('collectionCenter.pleaseCheckSite'));
        //   }
        // }
        console.log(obj, '---------');
        // 校验时间和单号二选一
        {
          const isBool = beforeSearch(obj);
          if (!isBool) {
            this.$message.warning(this.$t('receivablePayable.BusinessTimeOrOrderNumberCannotBeEmpty'));
            return;
          }
        }

        if (obj.numberList.length > 30000) {
          return this.$message.warning(this.$t('receivablePayable.InputNumberCannotExceed3000'));
        }

        if (obj.transportNumberList.length > 2000) {
          return this.$message.warning(this.$t('receivablePayable.TransportTrackingNumberQueryCannotExceed2000items'));
        }

        this.$emit('search', obj);
      } catch (e) {
        console.info(e);
      }
    },

    // 取消
    onClose() {
      this.$emit('close');
    },
    /**
     * @description 获取收发件人州省
     */
    getState() {
      const params = {
        pageNumber: 1,
        pageSize: 200,
        params: {
          countryName: 'Brazil'
        }
      };
      selectState(params, false).then((res) => {
        if (res.code === 200) {
          this.stateList = res.data.records;
        }
      });
    }
  }

};
</script>

<style scoped lang="scss">
.form-footer {
  text-align: center;
}
</style>
